import React from 'react';
import { CFBaseIconVariant } from '../utilities';
export const CFIconNavigation = {
    alias: 'navigation',
    defaultTitle: 'Navigation',
    source: ({ Path }, { variant }) => variant === CFBaseIconVariant.FILLED ? (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M20 21a1 1 0 0 1-.552-.166l-6.896-4.567a.998.998 0 0 0-1.104 0l-6.896 4.567a1.002 1.002 0 0 1-1.447-1.28l8-16a1 1 0 0 1 1.79 0l8 16A1.001 1.001 0 0 1 20 21Z' }))) : (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M11.998 13.702c.192 0 .385.056.552.166l4.88 3.231-5.432-10.863L6.566 17.1l4.88-3.23c.167-.11.36-.167.552-.167ZM20 21a1 1 0 0 1-.552-.166L12 15.901l-7.448 4.933a1.002 1.002 0 0 1-1.447-1.28l8-16c.34-.679 1.451-.679 1.79 0l8 16A1.001 1.001 0 0 1 20 21Z' }))),
};
